<p-card>
  <div class="close-button-container">
    <p-button
      
      size="small"
      variant="text"
      (click)="close()"
      severity="info"
    >
    <i class="fa-solid fa-xmark"></i>
  </p-button>
  </div>
  <div class="content-container">
    <div class="left-section">
      <div class="notification-icon-container" [ngSwitch]="message.icon">
        <i
          *ngSwitchCase="notificationMessageIcon.checkmark"
          class="notification-icon-checkmark notification-icon fa-solid fa-circle-check"
        >
        </i>
        <div
          class="notification-icon-wrapper"
          *ngSwitchCase="notificationMessageIcon.fileExport"
        >
          <i
            class="notification-icon-export notification-icon notification-icon-small fa-solid fa-file-export"
          ></i>
        </div>
        <div
          class="notification-icon-wrapper"
          *ngSwitchCase="notificationMessageIcon.fileZip"
        >
          <i
            class="notification-icon-zip notification-icon notification-icon-small fa-solid fa-file-zipper"
          ></i>
        </div>
        <div
          *ngSwitchCase="notificationMessageIcon.fail"
        >
          <i
            class="fa-solid fa-circle-xmark error-color notification-icon"
          ></i>
          <i
            *ngSwitchCase="notificationMessageIcon.email"
            icon="envelope-open-text"
            class="notification-icon"
          ></i>
        </div>
      </div>
    </div>
    <div class="right-section">
      <div class="top-row">
        <div *ngIf="message?.date" class="notification-date">
          <p
            class="notification-date--bold notification-date--space-right"
            style="margin-right: 10px"
          >
            {{ message?.date | localizeDate : "MMMM dd, yyyy" }}
          </p>

          <p>
            {{ message?.date | localizeDate : "h:mm:ss a" }}
          </p>
        </div>

        <span>
          <span *ngIf="message?.status" class="notification-status">
            {{ message?.status }}
          </span>

          <span
            class="retry-content"
            *ngIf="message?.retry"
            (click)="retryOperation()"
          >
            {{ retry?.text || "retry" | translation }}
          </span>
        </span>
      </div>

      <div *ngIf="message?.progress">
        <p-progressbar
          [value]="message?.progress"
          [showValue]="false"
        ></p-progressbar>
      </div>

      <p [innerHTML]="message?.text"></p>

      <a *ngIf="message?.action" (click)="message.action()">{{
        message?.actionText || "Yes" | translation
      }}</a>

      <a *ngIf="message?.link" [routerLink]="message?.link?.href">{{
        message?.link?.text
      }}</a>
    </div>
  </div>
</p-card>
